<template>
  <div
    v-if="dialog"
    id="test"
    v-bind:style="{
      position: 'fixed',
      top: '0px',
      left: '0px',
      width: '100%',
      height: getMaxHeight(),
    }"
    style="z-index: 99999"
  >
    <div
      class="drag-content"
      v-on:mousedown="onClickOnArea($event)"
      v-on:mousemove="mouseMove"
    >
      <div
        z-index="1000"
        id="myсard"
        class="onCenter dialog-border"
        v-bind:style="{
          position: getPosition(),
          left: getLeft(),
          top: getTop(),
          transform: '',
        }"
        v-on:mousedown="(ev) => mouseDown(ev)"
      >
        <slot class="onCenter"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dialog'],
  model: {
    prop: 'dialog',
    event: 'dialogEv',
  },
  data() {
    return {
      form: null,
      isDrag: false,
      isMouseDown: false,
      offsetX: 0,
      offsetY: 0,
      dragLeft: 0,
      dragTop: 0,
      position: 'absolute',
      height: 0,
      maxheight: 0,
    };
  },
  computed: {},
  async mounted() {
    document.addEventListener('mouseup', this.mouseUp);
    this.maxheight = window.innerHeight;
  },
  methods: {
    getMaxHeight() {
      return window.innerHeight+ 'px';
    },
    mouseDown(ev) {
      this.isMouseDown = true;

      const pointX = ev.pageX;
      const pointY = ev.pageY;

      const elem = document.getElementById('myсard');

      const elemX = elem.offsetLeft;
      const elemY = elem.offsetTop;

      this.offsetX = pointX - elemX;
      this.offsetY = pointY - elemY;

      if (this.offsetY > 50) this.isMouseDown = false;
    },
    mouseMove(event) {
      if (this.isMouseDown) {
        this.isDrag = true;
        this.moveAt(event);
      }
    },
    moveAt(event) {
      if (this.isDrag) {
        this.position = 'absolute';
        this.width = document.getElementById('myсard').offsetWidth;
        this.dragLeft = event.pageX - this.offsetX;
        this.dragTop = event.pageY - this.offsetY;
      }
    },
    mouseUp() {
      this.isMouseDown = false;
      this.isDrag = false;
    },
    getPosition() {
      return this.position;
    },
    getLeft() {
      return this.dragLeft + 'px';
    },
    getTop() {
      return this.dragTop + 'px';
    },
    onClickOnArea(event) {
      if (!this.inForm(event)) this.$emit('dialogEv', false);
    },
    inForm(event) {
      var elem = document.getElementById('myсard');
      if (elem == null || elem == undefined) return;
      var height = elem.offsetHeight;
      var width = elem.offsetWidth;
      var top = elem.offsetTop;
      var left = elem.offsetLeft;
      var mouseX = event.pageX;
      var mouseY = event.pageY;
      var inX = mouseX >= left && mouseX <= left + width;
      var inY = mouseY >= top && mouseY <= top + height;

      return inX && inY;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.position = 'relative';
        this.dragTop = 0;
        this.dragLeft = 0;
        this.maxheight = window.innerHeight;
      }
    },
  },
};
</script>
<style>
.removeBoxShadow {
  -webkit-box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px,
    rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px;
  box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px,
    rgb(0 0 0 / 0%) 0px 0px 0px 0px;
}
.onCenter {
  width: min-content;
  margin: auto;
}
.dialog-border {
  box-shadow: 0px 8px 9px -5px rgb(0 0 0 / 20%),
    0px 15px 22px 2px rgb(0 0 0 / 14%), 0px 6px 28px 5px rgb(0 0 0 / 12%) !important;
}
.drag-content {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
}
</style>
